import React from 'react'
import { Stack, Typography } from '@mui/material'

import { MUTED_TEXT_SX, PALETTE } from '../styles'

type StatTileProps = {
  label: string
  value: string
}

const StatTile: React.FC<StatTileProps> = ({ label, value }) => (
  <Stack gap={0.5} sx={{ p: 1.5, borderRadius: '12px', bgcolor: PALETTE.tile, minWidth: 0 }}>
    <Typography sx={MUTED_TEXT_SX}>{label}</Typography>
    <Typography sx={{ fontSize: 18, fontWeight: 600, color: PALETTE.text }}>{value}</Typography>
  </Stack>
)

export default StatTile
